var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1799 22.8602L16.3766 18.0569C15.6214 18.7114 14.7403 19.2212 13.7333 19.5862C12.7264 19.9512 11.6565 20.1337 10.5236 20.1337C7.80482 20.1337 5.50139 19.1897 3.61333 17.3017C1.72528 15.4136 0.78125 13.1354 0.78125 10.4669C0.78125 7.79844 1.72528 5.52019 3.61333 3.63213C5.50139 1.74408 7.79223 0.800049 10.4859 0.800049C13.1543 0.800049 15.4263 1.74408 17.3017 3.63213C19.1772 5.52019 20.115 7.79844 20.115 10.4669C20.115 11.5494 19.9387 12.5941 19.5863 13.6011C19.2339 14.608 18.7052 15.5521 18.0003 16.4332L22.8792 21.2365C23.1057 21.4379 23.219 21.6959 23.219 22.0106C23.219 22.3252 23.0931 22.6085 22.8414 22.8602C22.6148 23.0868 22.3379 23.2 22.0107 23.2C21.6834 23.2 21.4065 23.0868 21.1799 22.8602ZM10.4859 17.8681C12.525 17.8681 14.262 17.1443 15.6969 15.6968C17.1318 14.2493 17.8493 12.506 17.8493 10.4669C17.8493 8.4278 17.1318 6.68449 15.6969 5.23698C14.262 3.78947 12.525 3.06572 10.4859 3.06572C8.42159 3.06572 6.66569 3.78947 5.21818 5.23698C3.77067 6.68449 3.04692 8.4278 3.04692 10.4669C3.04692 12.506 3.77067 14.2493 5.21818 15.6968C6.66569 17.1443 8.42159 17.8681 10.4859 17.8681Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c2d3727072e7e9805b7348e49df4de53.svg";
export { ForwardRef as ReactComponent };